import React, { memo } from "react";
import { StarIcon } from "@heroicons/react/20/solid";
import StarRatingComponent from "react-star-rating-component";

interface DisabledStarRatingProps {
  rating?: number;
  className?: string;
  starColor?: string;
  emptyStarColor?: string;
  size?: number;
  loading?: boolean;
}

const DisabledStarRating: React.FC<DisabledStarRatingProps> = memo(
  ({
    rating = 0,
    className = "",
    starColor = "#ffd700",
    emptyStarColor = "#ddd",
    size = 18,
    loading = false,
  }) => {
    const validRating = Math.min(Math.max(rating), 5);

    if (loading) {
      return (
        <div className={className}>
          <div className="h-2 w-1/2 bg-gray-200 rounded text-center m-auto p-0.5"></div>
        </div>
      );
    }

    return (
      <div
        className={className}
        role="img"
        aria-label={`Rating: ${validRating} out of 5 stars`}
      >
        <StarRatingComponent
          name="candidate-rating"
          starCount={5}
          value={validRating}
          editing={false}
          starColor={starColor}
          emptyStarColor={emptyStarColor}
          renderStarIcon={() => (
            <StarIcon
              style={{
                width: `${size}px`,
                height: `${size}px`,
                padding: "2px",
              }}
            />
          )}
        />
      </div>
    );
  }
);

DisabledStarRating.displayName = "DisabledStarRating";

export default DisabledStarRating;
